import Controller from './controller';
import { on } from '../helpers';
import View from './view';
import ProfileModel from './model';


const initPage = () => {
    // stop if wrong page!

    if (!document.querySelector('.page.profile')) {
        return;
    }
    const view = new View();
    const model = new ProfileModel(view.firstName, view.middleName, view.lastName, view.birthday.toString(), view.gender, view.enthinicty);
    const controller = new Controller(view, model);
    controller.reset();

    if (view.hasAnyFormErrors()) {
        view.enableFormEdit();
    }
}

on(window, 'load', initPage);
